module.exports = __webpack_public_path__ + "img/bg1.9bc667d7.webp";